import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import React, { useRef } from 'react';

import { useAuth } from '../../../hooks/use-auth';
import { InvitationItemTemplate } from './invitation-item-template';

export const AccountButton = () => {
  const { logout } = useAuth();
  const menu = useRef(null);

  const items = [
    {
      label: 'Profile',
      icon: 'pi pi-user',
    },
    {
      label: 'Invitations',
      icon: 'pi pi-envelope',
      template: InvitationItemTemplate,
    },
    {
      separator: true,
    },
    {
      label: 'About',
      icon: 'pi pi-info-circle',
    },
    {
      separator: true,
    },
    {
      label: 'Logout',
      icon: 'pi pi-external-link',
      command: logout,
    },
  ];

  const onAccountClick = (event: any) => {
    // @ts-ignore
    menu.current.toggle(event);
  };

  return (
    <>
      <Menu model={items} popup ref={menu} id="popup_menu" />
      <Button
        icon="pi pi-user"
        className="p-button-rounded p-button-secondary p-button-outlined"
        aria-label="User"
        onClick={onAccountClick}
        aria-controls="popup_menu"
        aria-haspopup
      />
      <Badge value="2" severity="info" className="account-badge"></Badge>
    </>
  );
};
